import {
    ChangeDetectorRef,
    Component,
    forwardRef,
    OnInit,
    ChangeDetectionStrategy,
    inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { QueryObserverResult } from '@tanstack/query-core';
import { AsyncPipe } from '@angular/common';
import { map, Observable } from 'rxjs';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { VirtualizationSettings } from '@progress/kendo-angular-dropdowns';
import { LocationDataService } from '../../services/location-data.service';
import { Carrier } from '../../models/location/carrier';

//<!-- FormGroup consumer -->
//<div formGroupName="common">
//    <app-carrier-filter formControlName="carriers"></app-carrier-filter>
//</div>

//<!-- ngModel consumer -->
//<app-carrier-filter [(ngModel)]="selectedCarriers"></app-carrier-filter>

@Component({
    selector: 'app-carrier-filter',
    templateUrl: './carrier-filter.component.html',
    styleUrls: ['./carrier-filter.component.scss'],
    imports: [AsyncPipe, LabelModule, DropDownsModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CarrierFilterComponent),
            multi: true,
        },
    ],
})
export class CarrierFilterComponent implements ControlValueAccessor, OnInit {
    private locationDataService = inject(LocationDataService);
    private cdr = inject(ChangeDetectorRef);

    public carriersQueryResults$?: Observable<
        QueryObserverResult<Carrier[], Error>
    >;

    public isDisabled: boolean = false;
    public value: string[] = [];
    public virtual: VirtualizationSettings = { itemHeight: 28 };

    private onChange: (value: string[]) => void = () => {};
    private onTouched: () => void = () => {};

    writeValue(value: string[]): void {
        this.value = value ?? [];
        this.cdr.markForCheck();
    }

    registerOnChange(fn: (value: string[]) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    handleValueChange(value: string[]): void {
        this.value = value;
        this.onChange(value);
    }

    handleBlur(): void {
        this.onTouched();
    }

    ngOnInit(): void {
        this.carriersQueryResults$ = this.locationDataService
            .getCarriers()
            .result$.pipe(
                map(
                    (result) =>
                        ({
                            ...result,
                            data: result.data?.map((carrier) => ({
                                ...carrier,
                                displayText: this.formatDisplayText(carrier),
                            })),
                        }) as QueryObserverResult<Carrier[], Error>,
                ),
            );
    }

    private formatDisplayText(carrier: Carrier): string {
        if (!carrier?.carrier_name) {
            return carrier?.scac ?? '';
        }

        return `${carrier.scac} (${carrier.carrier_name})`;
    }
}
